import React from 'react';

const Logo = ({ size = 'normal', showText = true }) => {
  const logoSize = size === 'small' ? 'w-12 h-12' : 'w-16 h-16';
  const textSize = size === 'small' ? 'text-lg' : 'text-xl';
  const subtextSize = size === 'small' ? 'text-xs' : 'text-xs';

  return (
    <div className="flex items-center">
      <div className={`${logoSize} mr-3`}>
        <img 
          src="/logo-lp2sdm.jpg" 
          alt="LP2SDM RTD-CL Logo" 
          className={`${logoSize} object-contain rounded`}
        />
      </div>
      {showText && (
        <div>
          <h1 className={`text-primary font-bold ${textSize}`}>Cosmic Intelligence</h1>
          <p className={`text-gray-600 ${subtextSize}`}>LP2SDM RTD-CL</p>
        </div>
      )}
    </div>
  );
};

export default Logo;
